/** Align with role administration field limits (Data Dictionary). */
export const ROLE_NAME_MAX_LEN = 255;
export const ROLE_DESCRIPTION_MAX_LEN = 2000;

import { validationMaxCharLimit } from './validationI18n';

export function maxCharLimitExceededError(): string {
  return validationMaxCharLimit();
}
